import React, { useEffect, useState } from 'react';
import { ORDER_STATUS } from '../../../common/constants/SharedConstants';
import { getTime, safeUpperCase, getAndCheckIfOneTrue } from 'common/utilities/utils';
import BillDescription from './BillDescription';
import DeliveryInfo from './DeliveryInfo';
import { OrderDeliveryDistaIFrame } from './orderDeliveryDistaIFrame';
import {
  isDeliveryDistaOrderCancelled,
  isDeliveryDistaOrderCreateAssign,
  isDeliveryDistaOrderDelivered,
  isDeliveryDistaOrderIFrame,
  isDeliveryDistaOrderIframeComponents,
} from 'components/paymentProcessPage/Container/paymentProcessingFn';
import OrderStatusDeliveryCard from './orderStatusDeliveryCard';
import { isMobileDevice } from '../../../common/utilities/utils';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { MAX_WAIT_DELIVERY_INTERVAL } from 'components/paymentProcessPage/Container/constants';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';

const { ConfirmedImg, TakeAwayImg, TakeawayCompleted } = IMAGE_PATH;
const getClassName = orderDetails => {
  if (getAndCheckIfOneTrue(isDeliveryDistaOrderCancelled(orderDetails), isDeliveryDistaOrderDelivered(orderDetails))) {
    return isDeliveryDistaOrderDelivered(orderDetails)
      ? 'distaIframeContainer-delivered'
      : (isDeliveryDistaOrderCancelled(orderDetails) && 'distaIframeContainer-cancelled') || '';
  } else {
    return '';
  }
};
const OrderReceivedDeliveryCard = ({ orderDetails = {}, orderReducerData = {}, tenantReducer = {} }) => {
  const { DELIVERED, SENT_TO_POS_COMPLETED, CREATED, ASSIGNED, CANCEL } = ORDER_STATUS;
  const { ORDER_RECEIVED, ORDER_READY, FOUND_DRIVER } = TRANSLATE_MAPPING_KEY;
  const [statusInfo, setStatusInfo] = useState({ imageSrc: '', statusMessage: '', showProgressBar: false });
  const [cardToFill, setCardToFill] = useState(0);
  const [checkDeliveryPOSCompleted, setCheckDeliveryPOSCompleted] = useState(false);

  const [isMobile, setMobileFooter] = useState(isMobileDevice(window.innerWidth));

  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileFooter(isMobileView);
  };

  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile]);

  const checkDistaIframeLoaded =
    isDeliveryDistaOrderIFrame(orderDetails) && !isDeliveryDistaOrderDelivered(orderDetails);

  const billDescriptionView = () => {
    return (
      <BillDescription
        orderReducerData={orderReducerData}
        tenantReducer={tenantReducer}
        enableAccordion='true'
        isOpenAccordion={checkDistaIframeLoaded}
        orderDetailsObj={orderDetails}
      />
    );
  };

  const getStatusMsgOnOrderStatus = orderDetailsData => {
    switch (safeUpperCase(orderDetailsData?.status)) {
      case SENT_TO_POS_COMPLETED:
        setCardToFill(1);
        if (!checkDeliveryPOSCompleted) {
          const maxWaitDelivery = setTimeout(() => {
            setCheckDeliveryPOSCompleted(true);
            maxWaitDelivery && clearTimeout(maxWaitDelivery);
          }, MAX_WAIT_DELIVERY_INTERVAL);
        }
        return {
          imageSrc: ConfirmedImg,
          statusMessage: ORDER_RECEIVED,
          showProgressBar: !checkDeliveryPOSCompleted,
        };
      case CREATED:
        setCardToFill(2);
        return {
          imageSrc: TakeAwayImg,
          statusMessage: ORDER_READY,
          showProgressBar: true,
        };
      case ASSIGNED:
        setCardToFill(3);
        return {
          imageSrc: TakeawayCompleted,
          statusMessage: FOUND_DRIVER,
          showProgressBar: true,
        };
      case DELIVERED:
      case CANCEL:
        setCardToFill(0);
        return {
          imageSrc: '',
          statusMessage: '',
          showProgressBar: false,
        };
      //no default
    }
  };

  useEffect(() => {
    setStatusInfo(getStatusMsgOnOrderStatus(orderDetails));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderDetails?.deliveryDistaRetryCountFlag, orderReducerData?.id]);

  const adjustViewForIframeDista = checkDistaIframeLoaded
    ? 'adjust-delivery-info bill-accordion-section'
    : 'bill-accordion-section';

  return (
    <div>
      <div className='OrderReceivedContainer'>
        <div className='content'>
          <div
            className={`NotifyOrderPlaced ${getClassName(orderDetails)} ${
              isDeliveryDistaOrderIframeComponents(orderDetails) ? ' distaIframeContainer' : ''
            }`}
          >
            {isDeliveryDistaOrderIframeComponents(orderDetails) ? (
              <OrderDeliveryDistaIFrame orderDetails={orderDetails} />
            ) : (
              <div className='tickimage'>
                <div>
                  <OrderStatusDeliveryCard
                    orderDetails={orderDetails}
                    status={safeUpperCase(orderDetails?.status)}
                    imageSrc={statusInfo?.imageSrc}
                    statusMessage={statusInfo?.statusMessage}
                    getTime={getTime}
                    cardToFill={cardToFill}
                    showProgressBar={statusInfo?.showProgressBar}
                  />
                </div>
              </div>
            )}
          </div>
          {!isMobile &&
            !isDeliveryDistaOrderIFrame(orderDetails) &&
            !isDeliveryDistaOrderDelivered(orderDetails) &&
            billDescriptionView()}
        </div>
        <div className={adjustViewForIframeDista}>
          {(isDeliveryDistaOrderCreateAssign(orderDetails) || isDeliveryDistaOrderIFrame(orderDetails)) && (
            <DeliveryInfo isMobile={isMobile} orderReducerData={orderReducerData} orderDetails={orderDetails} />
          )}
          {isDeliveryDistaOrderIFrame(orderDetails) && billDescriptionView()}
          {isMobile &&
            !isDeliveryDistaOrderIFrame(orderDetails) &&
            !isDeliveryDistaOrderDelivered(orderDetails) &&
            billDescriptionView()}
        </div>
      </div>
    </div>
  );
};
export default OrderReceivedDeliveryCard;
